import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler h-6 w-6",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><line x1=\"5\" y1=\"5\" x2=\"5\" y2=\"21\"></line><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"14\"></line><path d=\"M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0\"></path><path d=\"M5 14a5 5 0 0 1 7 0a5 5 0 0 0 7 0\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default render